/*
 * Milo, the AI assistant (docs/API.md §14) — the contract's enums as the console uses them.
 */

/** Where Milo is used (MiloSurface, §14.1). */
export enum MiloSurface {
    Guest   = 'guest',
    Screen  = 'screen',
    Console = 'console',
}

export const MILO_SURFACES: MiloSurface[] = [MiloSurface.Guest, MiloSurface.Screen, MiloSurface.Console]

/** Why Milo cannot be used (MiloUnavailableReason, §14.3). */
export enum MiloUnavailableReason {
    Disabled      = 'disabled',
    NotConfigured = 'not_configured',
    NoRoom        = 'no_room',
    Inactive      = 'inactive',
}

/** Which daily limit a code 48 hit (MiloLimit, §14.7). */
export enum MiloLimit {
    StayDaily   = 'stay_daily',
    UserDaily   = 'user_daily',
    TenantDaily = 'tenant_daily',
    Budget      = 'budget',
}

/** A proposal's state (MiloProposalState, §14.6). */
export enum MiloProposalState {
    Pending   = 'pending',
    Done      = 'done',
    Failed    = 'failed',
    Cancelled = 'cancelled',
    Expired   = 'expired',
}

/** What a console proposal does (MiloProposalKind, §14.6). */
export enum MiloProposalKind {
    Remote          = 'remote',
    ChannelEnabled  = 'channel_enabled',
    InvitationActive = 'invitation_active',
    GuestLinkRotate = 'guest_link_rotate',
    RequestAccept   = 'request_accept',
    RequestDelivered = 'request_delivered',
    RequestRefuse   = 'request_refuse',
    CheckIn         = 'check_in',
    CheckOut        = 'check_out',
    FeedbackReply   = 'feedback_reply',
    FeedbackStatus  = 'feedback_status',
    LocalEvent      = 'local_event',
    RemoveLocalEvent = 'remove_local_event',
    SeasonalTiles   = 'seasonal_tiles',
}

/** Where a local event proposal's picture comes from (MiloPictureSource, §14.6.1); '' = none. */
export enum MiloPictureSource {
    Source = 'source',
    Ai     = 'ai',
}

/** What the card does to a local event proposal's picture (MiloPictureAction, §14.6.1). */
export enum MiloPictureAction {
    Remove     = 'remove',
    Source     = 'source',
    Ai         = 'ai',
    Regenerate = 'regenerate',
}

/** The record open on the console page Milo is asked from (MiloRecordKind, §14.3 `page`). */
export enum MiloRecordKind {
    Feedback = 'feedback',
    Request  = 'request',
    Device   = 'device',
    Room     = 'room',
    Stay     = 'stay',
}

/** The answer stream's events (§14.5). */
export enum MiloStreamEvent {
    Start    = 'start',
    Avatar   = 'avatar',
    Activity = 'activity',
    Delta    = 'delta',
    Retract  = 'retract',
    Proposal = 'proposal',
    Done     = 'done',
    Error    = 'error',
}

/** The AI providers the installation can reason with (§14.2, Davor 2026-10-24). */
export enum MiloAiProvider {
    Anthropic = 'anthropic',
    OpenAi    = 'openai',
}

export const MILO_AI_PROVIDERS: MiloAiProvider[] = [MiloAiProvider.Anthropic, MiloAiProvider.OpenAi]

/** The provider whose key `POST /settings/milo/test` tries (§14.2). */
export enum MiloKeyProvider {
    Anthropic = 'anthropic',
    OpenAi    = 'openai',
    Soniox    = 'soniox',
}

/** What a provider's last failure was (MiloProviderErrorKind, §14.2). */
export enum MiloProviderErrorKind {
    Credit      = 'credit',
    Auth        = 'auth',
    RateLimit   = 'rate_limit',
    Overloaded  = 'overloaded',
    Server      = 'server',
    Request     = 'request',
    Timeout     = 'timeout',
    Unreachable = 'unreachable',
}

export const MILO_PROVIDER_ERROR_KINDS: string[] = Object.values(MiloProviderErrorKind)

/** The guest languages Milo speaks (the contract's Language). */
export const MILO_LANGUAGES = ['sl', 'en', 'de', 'it', 'hr', 'hu']
